import React from "react";
import { styled } from "@mui/material/styles";
var SidebarContentRoot = styled("div", {
  name: "AppSidebarContent",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  minHeight: 0,
  flexGrow: 1,
  overflow: "auto",
  display: "flex",
  flexDirection: "column"
});
export var SidebarContent = props => {
  return /*#__PURE__*/React.createElement(SidebarContentRoot, props);
};